/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  Box, Grid, makeStyles, Typography,
} from '@material-ui/core';

import archive from '../../assets/icons/text.png';
import file from '../../assets/icons/Vector.png';
import kamiprueba from '../../assets/img/bot-kami.png';

import NotesForLesson from './NotesForLesson';

const useStyles = makeStyles((theme) => ({
  containerLessons: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: theme.spacing(3),
  },
  lessonCard: {
    width: '25%',
    height: '160px',
    textAlign: 'center',
  },
  topicCard: {
    width: '30%',
    height: '160px',
    textAlign: 'center',
  },
  linkItem: {
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  kami: {
    width: '110px',
    height: '130px',
    transition: 'transform 0.5s linear',
    '&:hover': {
      transform: 'translateY(-30px)',
    },
  },
  textLink: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontSize: '15px',
    fontWeight: 400,
    margin: theme.spacing(2, 0),
  },
}));

function BreadcrumbsContent({ themes }) {
  const classes = useStyles();
  const paragram = useParams();
  const { course } = paragram;
  const [topicsFilter, setTopicsFilter] = useState([]);
  const optionParagram = Object.keys(paragram).length;

  useEffect(() => {
    if (themes) {
      setTopicsFilter(themes.filter((e) => e.name === course));
    }
  }, []);

  return (
    <Box>
      {optionParagram === 0 && (
        <Grid container direction="row">
          <Grid xs={11} className={classes.containerLessons}>
            {themes
            && themes
              .sort((a, b) => a.createdAt - b.createdAt)
              .map((topic) => (
                <Box className={classes.topicCard} key={topic.id}>
                  <Link
                    to={`/notes/${topic.name}`}
                    state={{
                      idTopic: topic.id,
                    }}
                    className={classes.linkItem}
                  >
                    <img src={file} alt="file" />
                    <Typography className={classes.textLink}>
                      {topic.name}
                    </Typography>
                  </Link>
                </Box>
              ))}
          </Grid>
          <Grid xs={1}>
            {' '}
            <img
              className={classes.kami}
              src={kamiprueba}
              alt="kami saludando"
            />
          </Grid>
        </Grid>
      )}
      {optionParagram === 1 && (
        <Grid container direction="row">
          <Grid xs={11} className={classes.containerLessons}>
            {topicsFilter
              .sort((a, b) => a.createdAt - b.createdAt)
              .map((topic) => topic.lessonsByUser
                .sort((a, b) => a.createdAt - b.createdAt)
                .map((lesson) => (
                  <Box className={classes.lessonCard} key={lesson.id}>
                    <Link
                      to={`/notes/${course}/lessons/${lesson.name}`}
                      state={{
                        idUser: lesson.idUser,
                        idLesson: lesson.idLesson,
                        idCourse: topic.idCourse,
                      }}
                      className={classes.linkItem}
                    >
                      <img src={archive} alt="file" />
                      <Typography className={classes.textLink}>
                        {lesson.name.length > 25
                          ? `${lesson.name.slice(0, 25)}...`
                          : lesson.name}
                      </Typography>
                    </Link>
                  </Box>
                )))}
          </Grid>
          <Grid xs={1}>
            <img
              className={classes.kami}
              src={kamiprueba}
              alt="Kami saludando"
            />
          </Grid>
        </Grid>
      )}
      {optionParagram === 2 && <NotesForLesson />}
    </Box>
  );
}

export default BreadcrumbsContent;
